import React, { Component } from "react";
import Trello from "node-trello";
import Members from "./Members";

const t = new Trello(
  "8398ffdb0c49b47c4052399bd04835f6",
  "48995953408538ac8828d96320244948d8fd26e4ac3103288b974519542fe69a"
);

class BoardsAssembler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cards: [],
      members: []
    };
  }

  async componentDidMount() {
    if (this.props.boards) {
      // Construct an array of cards.
      let cardsArray = [];
      let idMembersArray = [];
      let membersArray = [];

      this.props.boards.map((board, i, boards) => {
        if (board.lists) {
          board.lists.map((list, j, lists) => {
            if (list.cards) {
              list.cards.map((card, k, cards) => {
                const active =
                  list.name.toLowerCase() !== "backlog" &&
                  list.name.toLowerCase() !== "open" &&
                  list.name.toLowerCase() !== "done" &&
                  list.name.toLowerCase() !== "release candidate" &&
                  list.name.toLowerCase() !== "in production" &&
                  list.name.toLowerCase() !== "closed"
                    ? true
                    : false;

                if (card.name && card.name.indexOf("(") === 0) {
                  const indexOfCloseParen = card.name.indexOf(")");
                  const points = card.name.slice(1, indexOfCloseParen);
                  card.points = points;
                }

                if (card.idMembers) {
                  card.idMembers.map(assignee => {
                    function findMember(member) {
                      return member.id === assignee;
                    }
                    if (!idMembersArray.find(findMember)) {
                      idMembersArray.push({
                        id: assignee,
                        points: 0
                      });
                    }

                    if (card.points && active) {
                      function findIndex(member) {
                        return member.id === assignee;
                      }
                      const index = idMembersArray.findIndex(findIndex);
                      idMembersArray[index].points =
                        idMembersArray[index].points +
                        parseInt(card.points, 10);
                    }
                  });
                }

                const relevantCard = {
                  assignees: card.idMembers,
                  name: card.name,
                  active
                };
                cardsArray.push(relevantCard);
              });
            }
          });
        }
      });
      idMembersArray.map(member => {
        t.get(`/1/members/${member.id}`, (err, data) => {
          if (err) throw err;
          const membersArray = Array.from(this.state.members);
          data.points = member.points;
          membersArray.push(data);
          this.setState({ members: membersArray });
        });
      });
      this.setState({
        cards: cardsArray
      });
    }
  }

  render() {
    if (!this.state.members) {
      return <h1>loading</h1>;
    } else {
      return (
        <div className="">
          <Members members={this.state.members} />
        </div>
      );
    }
  }
}

export default BoardsAssembler;



// WEBPACK FOOTER //
// ./src/BoardsAssembler.js